import { Page } from "components/Page";
import Connection from "../features/connections/Connection";

export const ConnectionPage = () => {
  return (
    <Page title="Connection Page">
      <Connection />
    </Page>
  );
};
